import { IOrderHistory } from 'types/suscription/history.types';
import { SkeletonLoader } from 'components/SkeletonLoader/SkeletonLoader';
import { DataView } from 'components/DataView/DataView';
import { ClientAvatar } from 'components/ClientAvatar/ClientAvatar';
import { TplatformSubscription } from 'types/paymentDetails';
import { TcountryCode } from 'components/NudosComponents/BordFlag/BordFlag.types';
import { formatUserData } from './utils';

import './OrderSummaryCard.scss';

export interface IOrderCardOrgData {
  organizationId?: number;
  organizationName?: string;
  countryCode?: string;
  levelSubscription?: TplatformSubscription;
}

export interface IOrderCardUserData {
  firstName?: string;
  profilePhoto?: string;
  email?: string;
  lastName?: string;
  phone?: string;
  phoneCode?: string;
}

interface IOrderSummaryCard {
  id?: number | string;
  userData?: IOrderCardUserData;
  orgData?: IOrderCardOrgData;
  orderHistory?: IOrderHistory[];
  subtitle?: JSX.Element;
  status?: JSX.Element;
  responsibleUsers?: JSX.Element;
  lastUpdate?: JSX.Element;
  loading?: boolean;
  idLabel?: string;
  extraActions?: JSX.Element;
  confirmOrderButton?: JSX.Element;
}

export const OrderSummaryCard = ({
  id,
  idLabel = 'Orden',
  userData,
  orgData,
  subtitle,
  status,
  responsibleUsers,
  lastUpdate,
  loading,
  extraActions,
  confirmOrderButton
}: IOrderSummaryCard) => {
  const user = formatUserData(userData!);

  const orderDataCells = [
    {
      id: 'company',
      renderCell: () => (
        <ClientAvatar
          countryCode={orgData?.countryCode as TcountryCode}
          data={{ id: orgData?.organizationId, company: orgData?.organizationName, type: orgData?.levelSubscription }}
        />
      )
    },
    { title: 'Nombre de solicitante', id: 'user.fullName', defaultValue: 'Sin información' },
    { title: 'Número de contacto', id: 'user.phone', defaultValue: 'Sin información' },
    { title: 'Correo', id: 'user.email', defaultValue: 'Sin información' },
    {
      id: 'responsibleUsers',
      style: {
        flex: 'none',
        width: 210
      },
      renderCell: () => <div className="responsibleUsersContainer">{responsibleUsers}{extraActions}</div>
    }
  ];

  return (
    <div className="orderSummaryCard">
      <div className="orderHeadingSection">
        <div className="orderHeadingSectionContainer">
          <div className="orderHeadingSectionTitle">
            <p className="text numberOfOrder">
              {idLabel} N°{id}
            </p>
            {status}
            {confirmOrderButton}
          </div>
          {subtitle}
        </div>

        {!!loading && (
          <div className="orderSummaryCardSkeleton ">
            <SkeletonLoader height={10} width={100} />
            <SkeletonLoader height={10} width={100} />
          </div>
        )}
        {!loading && lastUpdate}
      </div>

      <div className="divider"></div>
      <div className="orderInfoSection">
        <DataView
          className="dataView"
          loading={loading}
          data={{
            user
          }}
          cells={orderDataCells}
        />
      </div>
    </div>
  );
};
